import { Breakpoints } from '@/hooks/useBreakpoint';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing[2]}px;

  width: 100%;
`;

export const CarouselWrapper = styled.div<{ $breakpoint: Breakpoints }>`
  position: relative;
  overflow: hidden;
  width: 100%;
`;

export const PlanoTrack = styled.div<{ $fotoAtual: number }>`
  display: flex;
  transition: transform 0.5s ease;
  transform: translateX(${({ $fotoAtual }) => `-${$fotoAtual * 100}%`});
  width: 100%;
  height: 100%;
`;

export const PlanoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  flex-shrink: 0;
`;

export const ContainerControles = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;
